'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutButtonPropsInterface = exports.CheckoutPropsInterface = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var CheckoutPropsInterface = exports.CheckoutPropsInterface = {
  termId: _react.PropTypes.number,
  currencyCode: _react.PropTypes.string.isRequired,
  itemConfigurations: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    merchandiseId: _react.PropTypes.number.isRequired,
    quantity: _react.PropTypes.number.isRequired
  }).isRequired).isRequired,
  productBasedOffers: _react.PropTypes.array.isRequired,
  additionalUnitQuantity: _react.PropTypes.number
};

var CheckoutButtonPropsInterface = exports.CheckoutButtonPropsInterface = _extends({}, CheckoutPropsInterface, {
  onClick: _react.PropTypes.func,
  onError: _react.PropTypes.func
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/checkout/CheckoutPropsInterface.js
// module id = 344
// module chunks = 3 4 5